
type CheckingLoginProps = {
    error: boolean
}

export const CheckingLogin = ({ error }: CheckingLoginProps) => {
    return <div className="cq-content">{error ? "Failed to authenticate user" :  "Checking Authentication"}</div>
}